import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { ShoppingBag, X } from 'lucide-react';
import { MOCKUP_URL } from './Mockup';
type Buyer = {
  name: string;
  city: string;
  minutes: number;
};

/** Small, loud purchase toast that cycles through buyers from Argentina. */
export function PurchasePopup({
  enabled = true
}: {
  enabled?: boolean;
}) {
  const reduce = useReducedMotion();
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [closed, setClosed] = useState(false);
  useEffect(() => {
    if (!enabled || closed) return;
    let hide: ReturnType<typeof setTimeout>;
    const show = () => {
      setVisible(true);
      hide = setTimeout(() => setVisible(false), 5000);
    };
    const first = setTimeout(show, 2500);
    const loop = setInterval(() => {
      setIndex(i => (i + 1) % BUYERS.length);
      show();
    }, 11000);
    return () => {
      clearTimeout(first);
      clearTimeout(hide);
      clearInterval(loop);
    };
  }, [enabled, closed]);
  const buyer = BUYERS[index];
  return <AnimatePresence data-id="element-7" data-mp="102zbbpnsbjbf">
      {enabled && visible && !closed && <motion.a key={index} href="#compra" initial={reduce ? {
      opacity: 0
    } : {
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={reduce ? {
      opacity: 0
    } : {
      opacity: 0,
      y: 16,
      scale: 0.96
    }} transition={{
      duration: 0.24,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-3 left-3 z-50 flex w-[calc(100%-1.5rem)] max-w-[290px] items-center gap-2.5 rounded-xl border-[3px] border-gold bg-mod-red p-2 pr-7 text-white shadow-[0_0_0_3px_#ffffff,0_12px_28px_-8px_rgba(0,0,0,0.45)]" data-id="element-8" data-mp="1004q3vwy5ugy">
          <span className="relative h-11 w-11 shrink-0 overflow-hidden rounded-lg bg-white" data-id="element-9" data-mp="19yaoi3jjoih2">
            <img src={MOCKUP_URL} alt="" className="h-full w-full object-contain" data-id="element-10" data-mp="1xo524nboub2d" />
          </span>
          <span className="min-w-0 text-[12px] leading-snug" data-id="element-11" data-mp="22j15ukqaemvb">
            <span className="block font-extrabold" data-id="element-12" data-mp="2cbluhs85k7vc">
              {buyer.name} · {buyer.city}
            </span>
            <span className="block font-medium" data-id="element-13" data-mp="27ed8thnsplpc">compró el libro digital Terapia Lista</span>
            <span className="mt-0.5 flex items-center gap-1 text-[10px] font-bold text-gold" data-id="element-14" data-mp="22dfrt8eiuxpf">
              <ShoppingBag className="h-3 w-3" data-id="element-15" data-mp="1ycdr0n4yidlc" /> Hace {buyer.minutes} min · Argentina
            </span>
          </span>
          <button type="button" aria-label="Cerrar" onClick={e => {
        e.preventDefault();
        setClosed(true);
      }} className="absolute right-1.5 top-1.5 rounded p-0.5 text-white/80 hover:text-white" data-id="element-16" data-mp="1tfdnaivkxmxe">
            <X className="h-3.5 w-3.5" data-id="element-17" data-mp="1eqr4u8anof1y" />
          </button>
        </motion.a>}
    </AnimatePresence>;
}
const BUYERS: Buyer[] = [{
  name: 'Valeria G.',
  city: 'Rosario, Santa Fe',
  minutes: 3
}, {
  name: 'Mariana L.',
  city: 'Córdoba Capital',
  minutes: 7
}, {
  name: 'Florencia R.',
  city: 'La Plata, Bs. As.',
  minutes: 12
}, {
  name: 'Carolina S.',
  city: 'Mendoza',
  minutes: 5
}, {
  name: 'Agustina P.',
  city: 'San Miguel de Tucumán',
  minutes: 9
}, {
  name: 'Lucía F.',
  city: 'Mar del Plata',
  minutes: 14
}, {
  name: 'Romina D.',
  city: 'Neuquén',
  minutes: 4
}, {
  name: 'Silvana M.',
  city: 'CABA',
  minutes: 18
}];